const allowedDomains = [
  'expatelitesingles.com',
  'upendo-halisi.com',
  'penzi-halisi.com',
];

export function getSiteDomain(defaultDomain = 'expatelitesingles.com') {
  if (typeof window === 'undefined') {
    return defaultDomain;
  }

  const host = (window.location?.hostname || '').toLowerCase();
  const match = allowedDomains.find(
    (domain) => host === domain || host.endsWith(`.${domain}`),
  );

  return match || defaultDomain;
}

export function getSiteUrl(defaultDomain = 'expatelitesingles.com') {
  const domain = getSiteDomain(defaultDomain);
  const protocol = (typeof window !== 'undefined' && window.location?.protocol) || 'https:';
  return `${protocol}//${domain}`;
}
